import { ShopUsersApiClient } from '@fourthwall/services/dist/ShopUsersApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useUsersQuery = createQueryHook(ShopUsersApiClient.getUsers, {
  queryKey: ['users'],
})
